import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';

interface HeaderProps {
    bordered?: boolean;
}

const headerColor = theme('brand', {
    brenntag: colors.brenntag.secondary, 
    bcd: colors.bcd.primary
});

export const SHeader = styled.h3<HeaderProps>`
    color: ${headerColor};
    font-size: 18px;
    line-height: 28px;
    font-weight: normal;
    border-color: ${props => props.bordered && headerColor};
    border-bottom: ${props => props.bordered && '1px solid'};
    ${props => props.bordered && `
        padding-bottom: 15px;
    `};
    margin: 0;
`;